import i18n from '../../i18n';

const LINKEDIN_HOST_REGEX = /(^|\.)linkedin\.com$/i;
const LINKEDIN_PATH_REGEX = /^\/(in|company|school)\/([^/?#]+)/i;

export const normalizeSetupLinkedInUrl = (input) => {
  if (!input) return '';

  let raw = String(input).trim().replace(/^\uFEFF/, '').replace(/^@+/, '');
  if (!raw) return '';

  const withProtocol = /^https?:\/\//i.test(raw) ? raw : `https://${raw.replace(/^\/+/, '')}`;

  let url;
  try {
    url = new URL(withProtocol);
  } catch {
    return '';
  }

  if (!LINKEDIN_HOST_REGEX.test(url.hostname)) return '';

  const match = url.pathname.match(LINKEDIN_PATH_REGEX);
  if (!match) return '';

  const type = match[1].toLowerCase();
  const slug = match[2].trim();
  if (!slug) return '';

  return `https://linkedin.com/${type}/${slug}`;
};

export const validateSetupLinkedInUrl = (value) => {
  const trimmed = value?.trim?.() || '';
  if (!trimmed) {
    return { value: '', error: i18n.t('ai.validation.linkedinRequired') };
  }

  const normalized = normalizeSetupLinkedInUrl(trimmed);
  if (!normalized) {
    return {
      value: '',
      error: i18n.t('ai.validation.linkedinInvalid'),
    };
  }

  return { value: normalized, error: '' };
};

export const validateOptionalLinkedInUrl = (value) => {
  const trimmed = value?.trim?.() || '';
  if (!trimmed) {
    return { value: null, error: '' };
  }

  const normalized = normalizeSetupLinkedInUrl(trimmed);
  if (!normalized) {
    return {
      value: '',
      error: i18n.t('ai.validation.linkedinInvalid'),
    };
  }

  return { value: normalized, error: '' };
};
